// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface ReadAllNotificationsRequestPayload {
  success: () => void;
}

export interface ReadAllNotificationsSuccessPayload {}

export interface ReadAllNotificationsFailPayload {
  error: Error;
}

export const readAllNotificationsActions = createAsyncAction(
  'elearning/POST_READ_ALL_NOTIFICATIONS',
  'elearning/POST_READ_ALL_NOTIFICATIONS_SUCCESS',
  'elearning/POST_READ_ALL_NOTIFICATIONS_FAIL'
)<
  ReadAllNotificationsRequestPayload,
  ReadAllNotificationsSuccessPayload,
  ReadAllNotificationsFailPayload
>();
